import DownArrowIcon from "../assets/icons/downArrow";

const Downloadbroch = () => {
    return (
       <div className="w-full bg-white flex items-center justify-center xl:h-[324px] lg:h-[324px] md:h-[324px] sm:h-[269px] h-[269px]">
				<div className="flex flex-col xl:flex-row lg:flex-row h-full xl:w-[1200px] lg:w-[900px] md:w-[600px] sm:w-[354px] w-[354px] xl:justify-between lg:justify-between md:justify-center sm:justify-center justify-center items-center xl:gap-0 lg:gap-0 md:gap-[16px] sm:gap-[16px] gap-[16px]">
					<span className="text-black text-center sm:text-center md:text-center lg:text-left xl:text-left xl:w-[418px] lg:w-[418px] md:w-[418px] w-[300px] xl:text-[52px] lg:text-[52px] md:text-[45px] text-[28px] leading-[120%] xl:font-normal lg:font-normal md:font-normal sm:font-bold font-bold text-goudy">
						<span className="block md:hidden">
							Explore Our Range of Products
						</span>

						<span className="hidden md:block">
							Our Exclusive Range of Products
						</span>
					</span>
					<a
						href="/brochure.pdf"
						download="Product-Brochure.pdf"
						className="w-fit h-[47px] flex items-center justify-center gap-[10px] rounded-[30px] bg-black px-6 py-2 shadow-[0_4px_20px_0_#0000001F] cursor-pointer"
					>
						<span className="text-white text-[14px] xl:text-[16px] lg:text-[16px] font-medium leading-[100%] font-google">
							Download Product Brochure
						</span>
						<DownArrowIcon />
					</a>
				</div>
			</div>
    )
}
export default Downloadbroch;